export default __webpack_public_path__ + "static/media/finance.87d1c3ae.svg";